module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Front1"
    }
  }, [_c('p', {
    staticClass: "noindent3"
  }, [_vm._v("Vittorino dal Cengio wrote books about climbing in the Dolomites that were published during the 1980s. He also wrote articles and short stories for a magazine and for Italian newspapers in Canada. After an interlude, in 2008 he resumed writing books, this time about social history, authoring three in recent years. He moved to Canada in 1977 in the spirit of adventure after his military service with the Italian Alpine Corps. He holds various technical diplomas from Italy and a BA (joint major in French, History, Political Sciences) from Simon Fraser University.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c7d9353","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Front1.vue
// module id = 60
// module chunks = 0